import { PageNotFound404 } from "./layout";
import { CreateUser, AllUsers, EditUser, UserDetails } from "./auth";
import {
  AddRequest,
  AllItems,
  AllItemsBulkApproval,
  AllRequests,
  DelegationItems,
  FormSuccess,
  RequestDetails,
  ResubmitRequest,
} from "./requests";
import {
  AllQualityReports,
  SampleRequestApprovalProcurement,
} from "./procurement";
import { SupplierListMaster } from "./admin";

export const routes = [
  //404 page not found
  {
    path: "*",
    element: <PageNotFound404 />,
    access: [
      "sampleControl",
      "sampleControlView",
      "procurement",
      "chef",
      "executiveChef",
      "hod",
      "admin",
    ],
  },
  //landing routes
  {
    path: "/",
    element: <AllUsers />,
    access: ["admin"],
  },
  {
    path: "/",
    element: <AllItems />,
    access: ["sampleControl", "sampleControlView", "procurement"],
  },
  {
    path: "/",
    element: <AllItemsBulkApproval />,
    access: ["executiveChef", "hod", "chef"],
  },

  //request routes
  {
    path: "/delegateApprover",
    element: <DelegationItems />,
    access: ["chef", "procurement"],
  },
  {
    path: "/addRequest",
    element: <AddRequest />,
    access: ["procurement", "chef", "executiveChef", "hod"],
  },
  {
    path: "/success",
    element: <FormSuccess />,
    access: ["procurement", "chef", "executiveChef", "hod"],
  },
  {
    path: "/requestDetails/:id",
    element: <RequestDetails />,
    access: [
      "procurement",
      "chef",
      "executiveChef",
      "hod",
      "sampleControl",
      "sampleControlView",
    ],
  },
  {
    path: "/requestDetails/:id/:itemID",
    element: <RequestDetails />,
    access: [
      "procurement",
      "chef",
      "executiveChef",
      "hod",
      "sampleControlView",
      "sampleControl",
    ],
  },
  {
    path: "/resubmit/:id",
    element: <ResubmitRequest />,
    access: ["chef", "executiveChef"],
  },
  {
    path: "/allItems",
    element: <AllItems />,
    access: ["executiveChef", "chef", "hod"],
  },

  //procurement and sample control routes
  {
    path: "/procurementApproval/:id",
    element: <SampleRequestApprovalProcurement />,
    access: ["procurement"],
  },
  {
    path: "/qualityReports/:id",
    element: <AllQualityReports />,
    access: [
      "procurement",
      "sampleControl",
      "sampleControlView",
      "hod",
      "chef",
      "executiveChef",
    ],
  },
  {
    path: "/qualityReports",
    element: <AllQualityReports />,
    access: [
      "procurement",
      "sampleControl",
      "sampleControlView",
      "hod",
      "chef",
      "executiveChef",
    ],
  },
  {
    path: "/sampleRequests",
    element: <AllRequests />,
    access: [
      "procurement",
      "sampleControl",
      "sampleControlView",
      "hod",
      "chef",
      "executiveChef",
    ],
  },

  //admin routes
  {
    path: "/users",
    element: <AllUsers />,
    access: ["admin"],
  },
  {
    path: "/addUser",
    element: <CreateUser />,
    access: ["admin"],
  },
  {
    path: "/userDetails/:email",
    element: <UserDetails />,
    access: ["admin"],
  },
  {
    path: "/editUser/:email",
    element: <EditUser />,
    access: ["admin"],
  },
  {
    path: "/supplierList",
    element: <SupplierListMaster />,
    access: ["admin"],
  },
];
